<template>
  <li class="mb-8 pb-8 border-b border-gray-400">
    <article>
      <h3 class="text-xl">
        <a
          v-if="url"
          :href="url"
          class="link"
          :title="`Visit ${title}`"
          :aria-label="`Visit ${title}`"
          >{{ title }}</a
        >
        <span v-else class="text-primary">{{ title }}</span>
        <router-link
          v-if="attribution"
          to="/work#attr"
          class="link-basic text-xs italic"
          title="Go to Site Attribution"
          aria-label="Go to Site Attribution"
        >
          {{ attributionText }}<sup>*</sup>
        </router-link>
      </h3>
      <ul v-if="tags" class="list-none mt-2">
        <li v-for="(tag, i) in tags" :key="`tag-${i}`" class="text-sm inline">
          <!-- eslint-disable-next-line -->
          {{ tag }}{{ i < tags.length - 1 ? ", " : "" }}
        </li>
      </ul>
    </article>
  </li>
</template>

<script>
/**
 * @name Project Item
 * @description outputs array of provided projects
 * @vue-prop {string} title
 * @vue-prop {string} url
 * @vue-prop {array} tags
 * @vue-prop {boolean} attribution
 * @vue-prop {string} attributionText, default - " for Cosmic"
 * @example <project-item v-for="(project, i) in projects" v-bind="{..project}" :key="`project-${i}`" />
 */
export default {
  props: {
    title: String,
    url: String,
    tags: Array,
    attribution: Boolean,
    attributionText: {
      type: String,
      default: " for Cosmic"
    }
  }
};
</script>
